export default __webpack_public_path__ + "static/media/soriana2.fc4e3408.jpg";